import { DataBean } from "../DataBean";

export class PublicKeyInfo extends DataBean {

    public async securitymanager(): Promise<any> {
        return this.getCustomService("OrangeCore", "com.advantage.bean.securitymanager.PublicKeyInfo_getPublicKeyForApiRest_String", []);
    }

}
